// Imports
import { Route, Navigate, Outlet } from 'react-router-dom';
import NotFound from './shareables/foundation/admin-ui/components/pages/not-found';
import ContentErrorBoundary from './shareables/foundation/admin-ui/components/resources/content-error-boundary';
import websitesSectionRoutes from './components/sections/websites/section-routes';
import billingSectionRoutes from './components/sections/billing/section-routes';
import ResellerProvider from './components/resources/reseller-provider';
import ActivityLog from './components/sections/activity-log';


// Routes
const appRoutes = (
	<Route
		element={
			<ContentErrorBoundary>
				<ResellerProvider>
					<Outlet />
				</ResellerProvider>
			</ContentErrorBoundary>
		}
	>
		<Route index element={<Navigate to='/websites' replace />} />
		{websitesSectionRoutes}
		{billingSectionRoutes}
		<Route path='/activity-log' element={<ActivityLog />} />
		<Route path='*' element={<NotFound />} />
	</Route>
);

export default appRoutes;
